import React, { useState, useEffect } from "react";
import Widget from "components/Widget";
import { Row, Col, Empty } from 'antd';
import HomePageBankList from '../../../routes/BankPage/HomePageBankList'
import { useMediaQuery } from 'react-responsive'
import RequestHandler from "../../../util/RequestHandler";

const TicketList = (props) => {
  const [tenantAccounts, setTenantAccounts] = useState([{ data: [], total: 0 }]);
  const [dataState, setDataState] = useState([{ skip: 0, take: 10 }]);
  const [skip, setSkip] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    RequestHandler.get(`/TenantAccount?$count=true&$skip=${skip}&$top=10`).then(response => {
      setTenantAccounts({
        data: response.value,
        total: response['@odata.count']
      })
      setCount(response['@odata.count'])
    });
  }, [setDataState, skip, setSkip]);

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isLittleWith = useMediaQuery({
    query: '(max-width: 1336px)'
  });
  return (
    isTabletOrMobile ?
      <Row>
        <Col style={{ marginLeft: 17, width: '91%', marginBottom: 20 }}>
          <Widget title={
            <h2 className="h4 gx-text-capitalize gx-mb-0">
              Banka Hesapları</h2>
          } styleName="gx-card-ticketlist"
            extra={<h5 className="gx-text-primary gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">

            </h5>}>
            <div key={"TicketItem"} className="gx-media gx-task-list-item gx-flex-nowrap">
              <Col span={24} style={{ overflowY: 'auto' }} >
                <HomePageBankList isDigitHomePage={props.isDigitHomePage} />
              </Col>
            </div>
            <a href="bank-accounts">Tüm Hesaplar{" "}
            <img src={require(`assets/images/Icons/ChevronLeft.svg`)} alt="icon" style={{ width: 23, height: 23 }} /></a>
          </Widget>
        </Col>
      </Row>
      :
      <Widget title={
        <h2 className="gx-text-capitalize gx-mb-0">
          Banka Hesapları</h2>
      } styleName="gx-card-ticketlist"
        extra={<h2 className="gx-mb-0 gx-pointer gx-d-none gx-d-sm-block">
          <a href="bank-accounts" className="ak-jumbo-grey-text">Tüm Hesaplar{" "}
          <img src={require(`assets/images/Icons/ChevronLeft.svg`)} alt="icon" style={{ width: 23, height: 23 }} /></a>
        </h2>}>
        <div key={"TicketItem"} className="gx-media gx-task-list-item gx-flex-nowrap">
          {
            count === 0 ?
              <Col span={24} style={{ height: 490 }}>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
              </Col>
              :
              (
                count < 5 ? <Col span={24} style={{ height: 490 }}>
                  <HomePageBankList isDigitHomePage={props.isDigitHomePage} />
                </Col>
                  :
                  (
                    isLittleWith ?
                      <Col span={24} >
                        <HomePageBankList isDigitHomePage={props.isDigitHomePage} />
                      </Col>
                      :
                      <Col span={24} style={{ height: 800 }}>
                        <HomePageBankList isDigitHomePage={props.isDigitHomePage} />
                      </Col>
                  )
              )
          }
        </div>
      </Widget>
  );
}


export default TicketList;
